<template>
  <export-excel
    type="csv"
    class="export_btn"
    :name="`CI list (${$route.params.month}/${$route.params.year}).csv`"
    :data="exportData"
    :footer="[`${$route.params.month}/${$route.params.year}`]"
  >
    <v-icon color="white" left>mdi-chevron-right-circle-outline</v-icon>
    Export
  </export-excel>
</template>

<script>
export default {
  props: {
    ciData: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    exportData() {
      return (this.ciData || []).map((item, index) => ({
        No: index + 1,
        Name: item.presumptive ? item.presumptive.name : "",
        Code:
          item.patient && item.patient.mdrtb_reg_no
            ? item.patient.mdrtb_reg_no
            : "",
        Year:
          item.patient && item.patient.mdrtb_reg_year
            ? item.patient.mdrtb_reg_year
            : "",
        "Screening Township": item.township ? item.township.name : "",
        "Cross Township": item.screening_township
          ? item.screening_township.name
          : "",
        "Screening Person":
          item.screening_person == "1" ? "Volunteer" : "FO",
        "Symptom Screening":
          item.symptom_screening == "1" ? "No" : "Yes",
        Refer: item.refer == "1" ? "No" : "Yes",
        Date: item.date,
      }));
    },
  },
};
</script>

<style scoped>
.export_btn {
  background: #ff4081;
  border-radius: 3px;
  color: white !important;
  letter-spacing: 1px;
  text-transform: uppercase;
  width: 150px;
  padding: 5px 15px;
  margin-bottom: 1px;
  cursor: pointer;
}
</style>

